const Arrow = ({ className }) => {
  return (
    <>
      <svg
        className={className}
        width="20"
        height="12"
        viewBox="0 0 20 12"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19.3129 11.9152C19.4478 11.8592 19.5704 11.7771 19.6736 11.6736C19.7771 11.5704 19.8592 11.4478 19.9152 11.3129C19.9712 11.1779 20 11.0332 20 10.8871C20 10.741 19.9712 10.5963 19.9152 10.4613C19.8592 10.3263 19.7771 10.2038 19.6736 10.1006L10.7862 1.21317C10.683 1.10972 10.5605 1.02764 10.4255 0.971633C10.2905 0.915629 10.1458 0.8868 9.99971 0.8868C9.85358 0.8868 9.7089 0.915628 9.57393 0.971633C9.43896 1.02764 9.31637 1.10972 9.21318 1.21317L0.325791 10.1006C0.11719 10.3092 1.23084e-07 10.5921 9.72935e-08 10.8871C7.15032e-08 11.1821 0.117189 11.465 0.32579 11.6736C0.534393 11.8822 0.817318 11.9994 1.11233 11.9994C1.40733 11.9994 1.69026 11.8822 1.89886 11.6736L9.99971 3.57055L18.1006 11.6736C18.2038 11.7771 18.3263 11.8592 18.4613 11.9152C18.5963 11.9712 18.741 12 18.8871 12C19.0332 12 19.1779 11.9712 19.3129 11.9152Z" />
      </svg>
    </>
  );
};

export default Arrow;
